import React from 'react';
import PortalHeader from "./PortalHeader.js";
import PaymentOptions from './PaymentOptions.jsx';  
import Alert from './Alert.js';
import '../styles/portal_header.css';
import { buildUrlWithUTM } from '../utils/utmUtils.js'; 

const PaymentOptionsPage = () => {
  return (
    <>
      <PortalHeader>
        <nav className="nav-links">
          <a href={buildUrlWithUTM("/portal")} className="nav-link" onClick={(e) => { e.preventDefault(); window.location.href = buildUrlWithUTM('/portal'); }}>Home</a>
        </nav>
        <button className="logout-button" onClick={() => {
          localStorage.clear();
          window.location.href = buildUrlWithUTM('/portal/login');
        }}>
          Logout
        </button>
      </PortalHeader>

      <div style={{ padding: '2rem' }}>
        <PaymentOptions />
      </div>
    </>
  );
};

export default PaymentOptionsPage;